import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3014f4b1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section vecura-teaser" }
const _hoisted_2 = { class: "vecura-teaser__panel" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vecura-teaser__copy" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Vecura"),
  /*#__PURE__*/_createElementVNode("h2", null, "Vecura zeigt, worauf diese Arbeit hinausläuft."),
  /*#__PURE__*/_createElementVNode("span", null, " Als Mitgründer und COO baue ich dort eine RAG-Plattform für Organisationen auf, deren Wissen in Dokumenten, Prozessen und Fachkontext steckt. ")
], -1))
const _hoisted_4 = { class: "vecura-teaser__meta" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Mitgründer & COO"),
  /*#__PURE__*/_createElementVNode("span", null, "Firma, Produktfokus und operative Struktur")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "RAG-Plattform"),
  /*#__PURE__*/_createElementVNode("span", null, " Retrieval, Quellenbezug und integrierbare Wissensanwendungen ")
], -1))
const _hoisted_7 = {
  class: "button-link",
  href: "/vecura"
}

import ArrowRightIcon from "@/components/icons/ArrowRightIcon.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'VecuraTeaser',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("a", _hoisted_7, [
          _createTextVNode(" Mehr zu Vecura "),
          _createVNode(ArrowRightIcon, { class: "button-link__svg-icon" })
        ])
      ])
    ])
  ]))
}
}

})